<template>
  <div class="trazado">
    <div class="md-layout">
        <div class="md-layout-item item-cert  md-size-30 md-small-size-100 phone-color" style="position: relative;">
            <div class="cert-home" style="position: relative;">
              <img src="@/assets/CUADRO-M-UP.png" alt="Cuadro de detalles" srcset="" class="">
            </div>
        </div>
        <div class="md-layout-item item-text-cert md-small-size-100 headline" style="text-align: justify; position: relative">
          <h1 class="subtitle headline" style="text-align: justify; color: #ffff">Certifica</h1>
          <p style="font-weight: bold;">Tus productos y servicios</p>
          <p>Con los sellos de Green Solutions estarás destacando aquellas acciones que has tomado para limpiar tu huella y  garantizado a tu cliente tu compromiso con el medio ambiente. <br /> Agrega valor a tu marca como empresa sustentable.</p>
          <div class="wrapper">
            <div class="link_wrapper">
              <a class="certificate btn-animate" id="u26208" @click="handleClick" >
                <img src="@/assets/date.svg" alt="Calendario" srcset="" width='20px' style="margin-right: 10px; margin-top: -5px" />
                <span>AGENDA UNA REUNIÓN</span> 
                <md-tooltip md-direction="right">Agenda una reunión con un ejecutivo</md-tooltip>  
              </a>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
   
  },
  methods: {
    handleClick() {
      gtag( 'event', 'Click',{
          event_category: 'Agendar',
          event_label: 'calendly',
          value: 0
      })
      this.$store.state.showDialog = true
    }
  },
  metaInfo: {
    //script: [{ src: "https://www.googletagmanager.com/gtag/js?id=UA-170891641-1", async: true, defer: true }]
  }
}
</script>

<style>

.trazado {
  padding: 0;
  margin-top: 12vh;
  width: 100vw;
}
.md-button {
  text-transform: none !important;
}

.item-text-cert {
  padding: 1vw 4vw 4vw 10vw ;
  background: #00d371;
  color: #fafafa !important;
  position: relative;
}
.item-text-cert > p {
  font-size: 1.5vw;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.5px;
  padding-right: 6vw;
}


.wrapper{
  position: relative;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.link_wrapper{
  position: relative;
}

a.certificate{
  display: block;
  width: 22vw;
  height: 4vw;
  line-height: 4vw;
  font-weight: bold;
  text-decoration: none;
  background: #707070;
  text-align: center;
  color: #fff !important;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all .35s;
  border-radius: 30px;
  -webkit-box-shadow: 5px 3px 17px -4px rgba(148,143,148,1);
  -moz-box-shadow: 5px 3px 17px -4px rgba(148,143,148,1);
  box-shadow: 5px 3px 17px -4px rgba(148,143,148,1);
  font-size: 1vw;
  cursor: pointer;
}

.btn:focus {
  outline: 2px dotted #01fdf2;
  border-radius: 55px;
}


.btn-animated:link,
.btn-animated:visited {
    text-transform: uppercase;
    text-decoration: none;
    display: inline-block;
    border-radius: 100px;
    transition: all .02s;
    position: absolute;
}

.btn-animated:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.btn-animated:active {
    transform: translateY(-1px);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}


.btn-animated::after {
    content: "";
    display: inline-block;
    height: 100%;
    width: 100%;
    border-radius: 100px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    transition: all .4s;
}


.btn-animated:hover::after {
    transform: scaleX(1.4) scaleY(1.6);
    opacity: 0;
}

  
</style>